{
  "ProductStarsRating": {
    "class": "product-rating-iframe",
    "title": "Product Star Rating",
    "widgetId": "wdg-11ee1f75-a940-4d66-90e2-6f935b959402",
    "htmlTemplate": ["<style type='text/css'>body{overflow: hidden}div[id^=trustbadge-container]{display: none !important;}ewc-full-grade-with-distribution-overlay{padding-bottom: 30px}</style>",
      "<script type='text/javascript' src='https://integrations.etrusted.com/applications/widget.js/v2' async='true' defer='true'></script>",
      "<etrusted-widget class='widget' data-etrusted-widget-id='$widgetId' data-sku='$productCode'></etrusted-widget>"]
  },

  "StoreReviewsStarsTrustedShopsComponent": {
    "class": "store-reviews-stars-iframe",
    "title": "",
    "widgetId": "wdg-4e3fb70a-ab5b-49fb-af71-d3c779d34ae9",
    "htmlTemplate": ["<style type='text/css'>body{overflow: hidden}div[id^=trustbadge-container]{display: none !important;}</style>",
       "<script type='text/javascript' src='https://widgets.trustedshops.com/js/X3FD64B3D73C5DF36B6F7411AA28A3E66.js'></script>",
       "<script type='text/javascript' src='https://integrations.etrusted.com/applications/widget.js/v2' async='true' defer='true'></script>",
       "<etrusted-widget class='widget' data-etrusted-widget-id='$widgetId'></etrusted-widget>"]
  },

  "StoreReviewsCarouselContent": {
    "class": "store-reviews-carousel-iframe",
    "title": "Store Reviews Section",
    "widgetId":"wdg-335f330b-2451-470b-814a-0f3dbd9243ce",
    "htmlTemplate": [
      "<style type='text/css'>body{overflow: hidden}div[id^=trustbadge-container]{display: none !important;}</style>",
      "<script type='text/javascript' src='https://widgets.trustedshops.com/js/X3FD64B3D73C5DF36B6F7411AA28A3E66.js'></script>",
      "<script type='text/javascript' src='https://integrations.etrusted.com/applications/widget.js/v2' async='true' defer='true'></script>",
      "<etrusted-widget class='widget' data-etrusted-widget-id='$widgetId'></etrusted-widget>"
    ]
  },
  "ProductReviewsTrustedShopsContent": {
    "class": "product-rating-iframe",
    "title": "Product Reviews Section",
    "widgetId":"wdg-c1154bfa-ec5d-4424-952c-1f4e3bb545a4",
    "htmlTemplate": [
      "<style type='text/css'>body{overflow: hidden}div[id^=trustbadge-container]{display: none !important;}</style>",
      "<script type='text/javascript' src='https://widgets.trustedshops.com/js/X3FD64B3D73C5DF36B6F7411AA28A3E66.js'></script>",
      "<script type='text/javascript' src='https://integrations.etrusted.com/applications/widget.js/v2' async='true' defer='true'></script>",
      "<etrusted-widget class='widget' data-etrusted-widget-id='$widgetId' data-sku='$productCode'></etrusted-widget>"
    ]
  }
}
